import React, { Component } from 'react'
import { getKeyNameStore } from './utils'

const withMobX =
  (getStores = {}) =>
  (App) => {
    return class AppWithMobx extends Component {
      static async getInitialProps(appContext) {
        let appProps = {}
        const { req } = appContext.ctx
        const { jwt, clientURL, ssrURL, csrfToken, headers } = req || window.__NEXT_DATA__.props

        // current version from package.json
        const VERSION = headers ? headers['HUB_NEXT_VERSION'] : ''

        // Provide the store to getInitialProps of pages
        appContext.ctx.store = {}
        const fromReverseProxy = {
          jwt,
          clientURL,
          ssrURL,
          csrfToken,
        }

        for (const storeName in getStores) {
          const storeKeyName = getKeyNameStore(storeName)
          appContext.ctx.store[storeKeyName] = getStores[storeName](null, fromReverseProxy, VERSION)
        }

        if (typeof App.getInitialProps === 'function') {
          appProps = await App.getInitialProps(appContext)
        }

        return {
          ...appProps,
          initialMobxState: appContext.ctx.store,
          fromReverseProxy,
          VERSION,
        }
      }

      constructor(props) {
        super(props)
        this.store = {}
        const { initialMobxState, fromReverseProxy, VERSION } = props

        for (const storeName in getStores) {
          const storeKeyName = getKeyNameStore(storeName)
          this.store[storeKeyName] = getStores[storeName](
            initialMobxState[storeKeyName],
            fromReverseProxy,
            VERSION
          )
        }
      }

      render() {
        // eslint-disable-next-line no-unused-vars
        const { initialMobxState, ...props } = this.props

        return <App {...props} store={{ ...this.store }} />
      }
    }
  }

export default withMobX
